<ng-content select="[common-content]"></ng-content>

<div class="stepper-header" [ngClass]="{ vertical: isVertical(), large: style() === 'large' }">
    @for (step of allSteps(); track $index) {
    <div [ngClass]="{ active: step.isActive, completed: step.isCompleted }" class="step">
        @if (style() === "small") {
        <floori-icon [name]="step.icon"></floori-icon>
        } @else if (style() === "large") {
        <div class="step-number-circle">
            <span class="step-number">{{ step.number }}</span>
        </div>
        }
        <div class="text">
            <span class="title">{{ step.title }}</span>
            <span class="subtitle">{{ step.subtitle }}</span>
        </div>
    </div>

    @if (!$last) {
    <div class="step-line"></div>
    } }
</div>

<div class="stepper-container">
    <ng-content select="[step-content]"></ng-content>
</div>
